import BackgroundImg from '../../media/background.png';

export const getLandingPageCoverStyles = () => ({
  background: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: `url("${BackgroundImg}") no-repeat`,
    backgroundSize: 'cover',
    paddingTop: '64px',
  },
  'background-s': {
    paddingTop: '16px',
  },
});
